import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import { useLanguage } from "../contexts/LanguageContext";
import { IMAGES } from "../data/site";

const programImages = ["funeral", "wedding", "orphan", "community"];

export default function Programs() {
  const { t } = useLanguage();

  return (
    <div data-testid="programs-page">
      <PageHero
        eyebrow={t.programs.eyebrow}
        title={t.programs.title}
        subtitle={t.programs.subtitle}
        image={IMAGES.wedding}
      />

      <section className="py-24">
        <div className="gk-container">
          <SectionHeader
            eyebrow={t.programs.eyebrow}
            title={t.programs.title}
            align="center"
          />

          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
            {t.programs.items.map((p, i) => (
              <motion.article
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ delay: i * 0.08, duration: 0.6 }}
                className="bg-white rounded-[2rem] overflow-hidden border border-black/5 shadow-sm hover:shadow-2xl hover:-translate-y-1 transition-all group"
                data-testid={`program-${i}`}
              >
                <div className="aspect-square overflow-hidden bg-[#0B5D1E]/5 flex items-center justify-center">
                  <img
                    src={IMAGES[programImages[i]]}
                    alt={p.title}
                    className="w-full h-full object-contain group-hover:scale-[1.02] transition-transform duration-700"
                  />
                </div>
                <div className="p-8">
                  <span className="text-xs tracking-[0.25em] font-bold uppercase text-[#B5651D]">
                    Program 0{i + 1}
                  </span>
                  <h3 className="mt-2 font-heading font-bold text-2xl lg:text-3xl text-neutral-900">
                    {p.title}
                  </h3>
                  <p className="mt-4 text-neutral-600 leading-relaxed">{p.desc}</p>
                  <Link
                    to="/contact"
                    data-testid={`program-${i}-cta`}
                    className="mt-6 inline-flex items-center gap-2 text-[#0B5D1E] font-semibold font-heading hover:gap-3 transition-all"
                  >
                    {t.common.learnMore} <ArrowRight size={16} />
                  </Link>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0B5D1E] text-white">
        <div className="gk-container text-center">
          <h2 className="font-heading font-bold text-3xl sm:text-4xl">
            {t.home.ctaTitle}
          </h2>
          <p className="mt-4 text-white/80 max-w-xl mx-auto">{t.home.ctaSubtitle}</p>
          <div className="mt-8 flex flex-wrap gap-4 justify-center">
            <Link to="/membership" data-testid="programs-join-btn" className="gk-btn-secondary">
              {t.common.joinCommunity}
            </Link>
            <Link to="/get-involved" data-testid="programs-donate-btn" className="gk-btn-ghost-light">
              {t.common.donateNow}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
